// flexinet-workflows-api
import {stage} from "../../../config/stage.ts";

const workflowsApi = {
    prod: {
        endpoint: 'https://5yjxhdncqjag5mgcgypwosnsq4.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
    },
    test: {
        endpoint: 'https://dkgo5p4d4fhf7mbmo2pn5hn3ye.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
    },
    dev: {
        endpoint: 'https://wbrmiua5qbg3rilb2q2fudkjpe.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
    },
    ide: {
        endpoint: 'https://wbrmiua5qbg3rilb2q2fudkjpe.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
    },
};

export const workflowsApiConfig = workflowsApi[stage];
